<section>
  <div class="tz">
    <div class="tz-2">
      <div class="tz-2-com tz-2-main" *ngIf="isOk">
        <h4>{{pageTitle | translate }}</h4>
        <!------------ no published experiences --------->
        <div class="tz-2-com tz-2-main" *ngIf="experiences.length == 0">
          <div class="center no_data_message">
            <div class="icon-content"><i class="fas fa-cubes"></i></div>
            {{"NO_PUBLISEHD_EXPERIENCE_MESSAGE" | translate}}
          </div>
        </div>
        <!------------ end no published experiences  --------->
        <div class="tz-mess db-list-com tz-db-table" >
          <div *ngIf="experiences.length > 9" class="listing-container">
            <app-listing-experience-item
              *ngFor="let item of experiences   | paginate: { itemsPerPage: 9, currentPage: p , id: 'experiencesPage'}"
              [data]="item" >
            </app-listing-experience-item>
          </div>
          <div *ngIf="experiences.length <= 9" class="listing-container">
            <app-listing-experience-item
              *ngFor="let item of experiences"
              [data]="item" >
            </app-listing-experience-item>
          </div>
        </div>
        <div class="row center-align"  *ngIf="experiences.length > 9">
          <pagination-controls (pageChange)="p = $event" id="experiencesPage"
                               previousLabel=""
                               nextLabel=""
                               directionLinks="true"
                               autoHide="false">
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
</section>
